export default "__VITE_ASSET__DlwoJ89R__"